import { useSelector } from "react-redux";

export const useIsStreamIdExist = () => {
  return useSelector(({ jackpots }) => jackpots?.streamId);
};

export const useSlots = () => {
  return useSelector(({ jackpots }) => jackpots.slots);
};

export const useCooldowns = () => {
  return useSelector(({ jackpots }) => jackpots.cooldowns);
};

export const useCurrentWin = () => {
  return useSelector(({ jackpots }) => jackpots.currentWin);
};

export const useHasSlots = () => {
  return useSelector(({ jackpots }) => jackpots.hasSlots);
};
